import { yupResolver } from "@hookform/resolvers/yup";
import { createColumnHelper } from "@tanstack/react-table";
import { Fragment, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom"; //M10-9862
import downArrow from "src/assets/down-arrow.svg";
import { Button, Input, Modal, Toggle } from "src/components";
import Loader from "src/components/ui/loader.component";
import VersioningCrate from "src/components/Versioning/versioningModal.component";
import { flattenObject, generateUniqueID } from "src/constants/functions";
import { invoiceActions } from "src/context/invoice-slice";
import { RootState } from "src/context/store";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import { toast } from "src/hooks/useToast";
import {
  entryInvoice,
  getCheckFullyInvoiced, //M10-10639
  getInvoiceActionAllowed,
  getInvoiceBatchList,
  getInvoiceChangeValidationV1,
  getInvoiceDetails,
  getInvoicePriceList,
  getOrderedProducts,
  getProductGstDetails,
  getSimilarCompanyProducts,
} from "src/services/invoice-api";
import Book from "../../assets/book.png";
import DeleteIcon from "../../assets/delete.svg";
import editPen from "src/assets/edit-pen.svg";
import PurpleLeftArrowIcon from "../../assets/purple-left-arrow.svg";
import SubTable from "../counter-details/sub-table.component";
import { getInvoiceDetailsInfo } from "../invoice-master/invoice-helper";
import InvoiceLayout from "../invoice-master/invoice-layout.component";
import InvoiceDetailCard from "./invoice-detail.component";
import { Transition } from "@headlessui/react";
import { MessageCircle } from "lucide-react";
import InvoiceRemarks from "./InvoiceRemarks";
import InvoiceEntryForm from "./InvoiceEntryCards/InvoiceEntryForm";
import { priceIdentifierList } from "./invoice-constants";
import { schema } from "./invoice-constants";
import { validateInvoiceProducts } from "./InvoiceEntryCards/InvoiceEntryUtility";
import EwayDetails from "./InvoiceEntryCards/EwayDetails";
import useDebounceLeading from "src/hooks/useDebounceLeading";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import usePermission from "src/hooks/usePermission";
import crossIcon from "src/assets/cross.svg";

const columnHelper = createColumnHelper();

interface selectedPriceIdentifier {
  key: string;
  description: string;
  priceldentifier_id: number;
}

export const InvoiceEntryScreen = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [cashDiscountPercent, setCashDiscountPercent] = useState(0);
  const [cashDiscountAmount, setCashDiscountAmount] = useState(0);
  const { invoiceDetails, invoicesTextractData } = useSelector((state: RootState) => state.invoice);
  const [selectedPriceIdentifier, setSelectedPriceIdentifier] = useState<selectedPriceIdentifier>({
    key: "",
    description: "",
    priceldentifier_id: 0,
  });
  const [quantity, setQuantity] = useState<number>(0);
  const [discountPercentage, setDiscountPercentage] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [price, setPrice] = useState<number>(0);
  const [useOrderedProducts, setUseOrderedProducts] = useState("ordered");
  const [itemCode, setItemCode] = useState<string>("");
  const [priceList, setPriceList] = useState<any[]>([]);
  const [batchList, setBatchList] = useState<any[]>([]);
  const [gstAmbiguous, setGstAmbiguous] = useState<boolean>(false);
  const [isConfirmingInvoice, setConfirmingInvoice] = useState<boolean>(false);
  const [netInvoiceAmount, setNetInvoiceAmount] = useState<string>(invoiceDetails?.invoice?.net_amount);
  const [selectedBatch, setSelectedBatch] = useState<any>({});
  const [mappedData, setMappedData] = useState<any[]>([]);
  const [tcs, setTcs] = useState<number>(0);
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const [VersioningModal, setVersioningModal] = useState(false);
  const [unknownBatch, setUnknownBatch] = useState<any[]>([]);
  const outSideClickRef = useOutsideClick(() => {
    setVersioningModal(false);
  });
  const [isRemarksShown, setIsRemarksShown] = useState(false);
  const [editingTextractProduct, setEditingTextractProduct] = useState<any>({});
  const [editingProductId, setEditingProductId] = useState<any>(null);
  const [isEwayApplicable, setIsEwayApplicable] = useState(false);
  const [isEwayExempt, setEwayExempt] = useState(false);
  const ref = useOutsideClick(() => {
    setIsRemarksShown(false);
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isApprovalCheck, setIsApprovalCheck] = useState(true);
  const [invalidItem, setInvalidItem] = useState<any[]>([]);

  //M10-10639
  const [isModalSOAOpen, setIsModalSOAOpen] = useState(false);
  const [isSaoData, setIsSaoData] = useState<any[]>([]);
  const [isSaoCheck, setIsSaoCheck] = useState<boolean>(false);
  //M10-10639
  const [isNetAmount, setIsNetAmount] = useState<any>({ status: false, confirm: false }); //netAmount=0

  const { hasPermission: viewRemarks } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.module,
    action: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.action,
  });

  //M10-9862
  const location = useLocation();
  const { CompanyCode } = location.state || {};

  const company_code = invoiceDetails?.company_code || CompanyCode;

  const navigate = useNavigate();


  const smartFormInstance = useForm({
    // @ts-ignore
    resolver: yupResolver(schema),
    mode: "onBlur",
    defaultValues: structuredClone({}),
  });

  const { withEventCheck } = useEventStatus();
  const dispatch = useDispatch();
  const { stockist_invoice_attachment_id } = useParams();

  const columns = [
    // //M10-9670 Start
    // columnHelper.accessor("sno", {
    //   header: "S.No",
    //   cell: (info: any) => info.row.index + 1,
    // }), //M10-9670 End
    columnHelper.accessor("item_description", {
      header: "Item Name",
      cell: (info: any) => info.row.original.item_description || "-",
    }),
    columnHelper.accessor("item_code", {
      header: "Item Code",
      cell: (info: any) => info.row.original.item_code || "-",
    }),
    columnHelper.accessor("inv_mrp", {
      header: "Inv. MRP",
      cell: (info: any) => info.row.original.inv_mrp || "0",
    }),
    columnHelper.accessor("inv_rate", {
      header: "Inv. Rate",
      cell: (info: any) => info.row.original.inv_rate || "-",
    }),
    columnHelper.accessor("ptr", {
      header: "Inv. PTR",
      cell: (info: any) => info.row.original.ptr || "0",
    }),
    columnHelper.accessor("quantity", {
      header: "Qty.",
      cell: (info: any) => info.row.original.quantity || "0",
    }),
    columnHelper.accessor("free_qty", {
      header: "Free Qty",
      cell: (info: any) => info.row.original.free_qty || "0",
    }),
    columnHelper.accessor("gross_amt", {
      header: "Gross Amt.",
      cell: (info: any) => info.row.original.gross_amt || "0",
    }),
    columnHelper.accessor("discount_type", {
      header: "Discount Defined By",
      cell: (info: any) => info.row.original.discount_type || "-",
    }),
    columnHelper.accessor("discount_amt", {
      header: "Discount %",
      cell: (info: any) => {
        const { discount_amt, inv_rate, quantity, discount_perc } = info.row.original;
        if (!quantity || quantity === 0 || !inv_rate) return "0.00";
        const discountPercent = Number(discount_perc) ? Number(discount_perc) : ((Number(discount_amt) / (Number(inv_rate) * Number(quantity))) * 100).toFixed(2); //M10-10769
        return discountPercent;
      },
    }),

    columnHelper.accessor("gst", {
      header: "GST %",
      cell: (info: any) => info.row.original.gst || info.row.original.p_gst_perc || "0",
    }),
    columnHelper.accessor("batch_no", {
      header: "Batch No.",
      cell: (info: any) => info.row.original.batch_no || "-",
    }),
    columnHelper.accessor("action", {
      header: "Action",
      cell: (info: any) => {
        const handleDelete = async (uniqueKey: string) => {
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button onClick={() => handleDelete(info.row.original.unique_key)}>
            <img src={DeleteIcon} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
    columnHelper.accessor("Edit", {
      header: "Edit",
      cell: (info: any) => {
        const handleEdit = async (uniqueKey: string) => {
          const { setValue }: any = smartFormInstance;
          setEditingProductId(info.row.original.invoice_product_id);
          setValue("itemName", info.row.original.item_description);
          setValue("itemCode", info.row.original.item_code);
          // setValue("mrp", value?.mrp || "");
          // setValue("price", value?.ptr || "");
          setPrice(info.row.original.inv_rate);
          setValue("batchNo", info.row.original.batch_no);
          setValue("discountAmount", info.row.original.discount_amt);
          setValue("discountPercentage", Number(info.row.original.discount_perc));
          setValue("freeQty", Number(info.row.original.free_qty));
          setValue("quantity", info.row.original.quantity);
          setValue("schemeType", info.row.original.discount_type);
          // const res = await getInvoicePriceList(info.row.original.item_code);
          setValue(
            "gst",
            Number(info.row.original.p_gst_perc) > 0 ? info.row.original.p_gst_perc : Number(info.row.original.gst) > 0 ? info.row.original.gst : "0"
          );
          setValue("itemPrice", { mrp: info.row.original.inv_mrp, ptr: info.row.original.ptr });
          setValue("price", Number(info.row.original.inv_rate));
          setValue("mrp", Number(info.row.original.inv_mrp));
          setValue("ptr", info.row.original.ptr);
          setValue("pts", info.row.original.pts); //M10-10856
          setSelectedBatch(info.row.original.batch_no);
          setQuantity(info.row.original.quantity);
          setDiscountPercentage(Number(info.row.original.discount_perc));
          setDiscountAmount(Number(info.row.original.discount_amt));

          if (info.row.original.discount_type === "Scheme") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
            setValue("schemeType", {
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
          } else if (info.row.original.discount_type === "Discount Percent") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
            setValue("schemeType", {
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
          } else if (info.row.original.discount_type === "Discount Amount") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
            setValue("schemeType", {
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
          }

          setItemCode(info.row.original.item_code);
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button
            onClick={() => {
              setEditingTextractProduct(info.row.original);
              handleEdit(info.row.original.unique_key);
            }}
          >
            <img src={editPen} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
  ];
  const columns2 = [
    // //M10-9670 Start
    // columnHelper.accessor("sno", {
    //   header: "S.No",
    //   cell: (info: any) => info.row.index + 1,
    // }), //M10-9670 End
    columnHelper.accessor("item_description", {
      header: "Item Name",
      cell: (info: any) => info.row.original.item_description || "-",
    }),
    columnHelper.accessor("item_code", {
      header: "Item Code",
      cell: (info: any) => info.row.original.item_code || "-",
    }),
    columnHelper.accessor("inv_mrp", {
      header: "Inv. MRP",
      cell: (info: any) => info.row.original.inv_mrp || "0",
    }),
    columnHelper.accessor("ptr", {
      header: "Inv. PTR",
      cell: (info: any) => info.row.original.ptr || "0",
    }),
    columnHelper.accessor("quantity", {
      header: "Qty.",
      cell: (info: any) => info.row.original.quantity || "0",
    }),
    columnHelper.accessor("gross_amt", {
      header: "Gross Amt.",
      cell: (info: any) => info.row.original.gross_amt || "0",
    }),
    columnHelper.accessor("discount_type", {
      header: "Discount Defined By",
      cell: (info: any) => info.row.original.discount_type || "-",
    }),
    columnHelper.accessor("discount_amt", {
      header: "Discount %",
      cell: (info: any) => {
        const { discount_amt, inv_rate, quantity } = info.row.original;
        if (!quantity || quantity === 0 || !inv_rate) return "0.00";
        const discountPercent = (discount_amt / (inv_rate * quantity)) * 100;
        return discountPercent.toFixed(2);
      },
    }),

    columnHelper.accessor("free_qty", {
      header: "Free Qty",
      cell: (info: any) => info.row.original.free_qty || "0",
    }),

    columnHelper.accessor("gst", {
      header: "GST %",
      cell: (info: any) => info.row.original.gst || info.row.original.p_gst_perc || "0",
    }),
    columnHelper.accessor("batch_no", {
      header: "Batch No.",
      cell: (info: any) => info.row.original.batch_no || "-",
    }),
    columnHelper.accessor("action", {
      header: "Action",
      cell: (info: any) => {
        const handleDelete = async (uniqueKey: string) => {
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button onClick={() => handleDelete(info.row.original.unique_key)}>
            <img src={DeleteIcon} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
    columnHelper.accessor("Edit", {
      header: "Edit",
      cell: (info: any) => {
        const handleEdit = async (uniqueKey: string) => {
          const { setValue }: any = smartFormInstance;
          setEditingProductId(info.row.original.invoice_product_id);
          setValue("itemName", info.row.original.item_description);
          setValue("itemCode", info.row.original.item_code);
          // setValue("mrp", value?.mrp || "");
          // setValue("price", value?.ptr || "");
          setPrice(info.row.original.inv_rate);
          setValue("batchNo", info.row.original.batch_no);
          setValue("discountAmount", info.row.original.discount_amt);
          setValue("discountPercentage", Number(info.row.original.discount_perc));
          setValue("freeQty", Number(info.row.original.free_qty));
          setValue("quantity", info.row.original.quantity);
          setValue("schemeType", info.row.original.discount_type);
          // const res = await getInvoicePriceList(info.row.original.item_code);
          setValue(
            "gst",
            Number(info.row.original.p_gst_perc) > 0 ? info.row.original.p_gst_perc : Number(info.row.original.gst) > 0 ? info.row.original.gst : "0"
          );
          setValue("itemPrice", { mrp: info.row.original.inv_mrp, ptr: info.row.original.ptr });
          setValue("price", Number(info.row.original.inv_rate));
          setValue("mrp", Number(info.row.original.inv_mrp));
          setValue("ptr", info.row.original.ptr);
          setValue("pts", info.row.original.pts); //M10-10856
          setSelectedBatch(info.row.original.batch_no);
          setQuantity(info.row.original.quantity);
          setDiscountPercentage(Number(info.row.original.discount_perc));
          setDiscountAmount(Number(info.row.original.discount_amt));

          if (info.row.original.discount_type === "Scheme") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
            setValue("schemeType", {
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
          } else if (info.row.original.discount_type === "Discount Percent") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
            setValue("schemeType", {
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
          } else if (info.row.original.discount_type === "Discount Amount") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
            setValue("schemeType", {
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
          }

          setItemCode(info.row.original.item_code);
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button
            onClick={() => {
              setEditingTextractProduct(info.row.original);
              handleEdit(info.row.original.unique_key);
            }}
          >
            <img src={editPen} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
  ];

  const handleAddProduct = async (data: any) => {
    if (Number(data?.freeQty) < 0 || !Number.isInteger(Number(data?.freeQty))) {
      toast({
        description: `Free Quantity can not be decimal or less than 0`,
        variant: "destructive",
      });
      return;
    }
    if ((Number(data?.freeQty) <= 0 || !Number.isInteger(Number(data?.freeQty))) && Number(quantity) <= 0) {
      toast({
        description: `Required Quantity or Free Quantity`,
        variant: "destructive",
      });
      return;
    }
    if (Number(quantity) < 0) {
      toast({
        description: `Quantity cannot be less than or equal to 0`,
        variant: "destructive",
      });
      return;
    }
    if (selectedPriceIdentifier?.key === "SCHEME") {
      if (Number(data?.freeQty) < 0) {
        toast({
          description: `Free Quantity cannot be less than 0`,
          variant: "destructive",
        });
        return;
      }
    }
    if (selectedPriceIdentifier?.key === "DISCOUNT_PERCENT" || selectedPriceIdentifier?.key === "DISCOUNT_AMOUNT") {
      if (Number(data?.discountPercentage) < 0 || Number(data?.discountPercentage) > 100) {
        toast({
          description: `Discount Percentage cannot be less than 0`,
          variant: "destructive",
        });
        return;
      }
    }
    const newBatchNo = data?.batchNo?.toUpperCase() as string;
    const hasZeroMRP = priceList?.filter(item => parseFloat(item?.mrp) === data?.mrp);
    if (hasZeroMRP.length == 0 && useOrderedProducts !== "unknown") {
      toast({
        description: `Incorrect MRP. Please check`,
        variant: "destructive",
      });
      return;
    }

    try {
      const payload = {
        invoice_id: Number(invoiceDetails?.invoice?.invoice_id),
        item_description: useOrderedProducts === "unknown" ? String(data?.itemName) : String(data?.itemName),
        item_code: useOrderedProducts === "unknown" ? String(data?.itemCode) : String(data?.itemCode),
        unique_key: editingProductId || String(data?.itemCode) + selectedBatch?.batch_no,
        quantity: Number(quantity) || 0,
        gst: data?.gst || "0",
        cash_dis_perc: selectedPriceIdentifier?.key === "DISCOUNT_PERCENT" || selectedPriceIdentifier?.key === "DISCOUNT_AMOUNT" ? Number(cashDiscountPercent) : 0,
        ptr: Number(data?.ptr) || 0,
        pts: Number(data?.itemPrice?.pts) ? Number(data?.itemPrice?.pts) : Number(data?.pts) || 0, //M10-10856
        discount_type: !selectedPriceIdentifier?.description ? "Discount Amount" : String(selectedPriceIdentifier?.description),
        free_qty: selectedPriceIdentifier?.key === "SCHEME" ? Number(data?.freeQty) : 0,
        batch_no: selectedBatch?.batch_no?.toUpperCase() || newBatchNo,
        inv_rate: String(price) || "0",
        mrp_valid: true,
        inv_mrp: String(data?.mrp) || "0",
        discount_amt: !selectedPriceIdentifier?.description ? "0" : selectedPriceIdentifier?.key === "DISCOUNT_PERCENT" || selectedPriceIdentifier?.key === "DISCOUNT_AMOUNT" ? (isNaN(Number(discountAmount)) ? "0" : String(discountAmount)) : '0',
        counter_code: invoiceDetails?.counter_code,
        is_item_unknown: useOrderedProducts === "unknown",
        gross_amt: (Number(price) * Number(quantity))?.toFixed(2),
        ...(editingTextractProduct && {
          invoice_product_id: editingTextractProduct.invoice_product_id,
        }),
        ucode: generateUniqueID(),
        id: editingTextractProduct?.id  //Add for serial No
      };
      setEditingTextractProduct([]);
      setMappedData((prev) => [...prev, payload]);
      if (newBatchNo && !batchList.some((batch) => batch.batch_no === newBatchNo)) {
        setUnknownBatch((prev) => [...prev, { batch_no: newBatchNo }]);
      }
      resetFormFields();
      setSelectedBatch({});
      setEditingProductId(null);
      // setBatchNo("");
      // Focus the item name field after form submission
      const itemNameField = document.querySelector('input[name="itemName"]');
      if (itemNameField instanceof HTMLElement) {
        itemNameField?.focus();
      }
      setIsSaoCheck(false)
    } catch (error) {
      console.log(error);
    }
  };

  const handleCashDiscountPercentChange = (value: string) => {
    const percent = parseFloat(value) || 0;
    setCashDiscountPercent(Number(percent?.toFixed(2)));
    setMappedData((prev) => {
      const updatedData = prev.map((item) => ({ ...item, p_cash_discount_perc: Number(percent?.toFixed(2)) }));
      return updatedData;
    });
    const discountAmount = (calculateSubtotal() * percent) / 100;
    setCashDiscountAmount(Number(discountAmount?.toFixed(2)));

    updateTotal(discountAmount);
  };

  const handleCashDiscountAmountChange = (value: string) => {
    const amount = parseFloat(value) || 0;
    setCashDiscountAmount(Number(amount?.toFixed(2)));

    const percent = (amount / calculateSubtotal()) * 100;
    setCashDiscountPercent(Number(percent?.toFixed(2)));

    setMappedData((prev) => {
      const updatedData = prev.map((item) => ({ ...item, p_cash_discount_perc: Number(percent?.toFixed(2)) }));
      return updatedData;
    });

    updateTotal(amount);
  };

  const updateTotal = (discountAmount: number) => {
    return (calculateSubtotal() - discountAmount).toFixed(2);
  };
  //M10-9685-MRP Related Issue - Add for serial No(sort & id)
  const rowsForItemsAddedTable = (isUnknown: boolean) => {
    const rows: any[] = [];
    mappedData?.length > 0 &&
      mappedData
        ?.filter((item: any) => item?.is_item_unknown === isUnknown)
        ?.sort((a: any, b: any) => (a?.textractProduct?.stockistfile_detail_code || 0) - (b?.textractProduct?.stockistfile_detail_code || 0))
        .forEach((element: any) => {
          let modElement = JSON.parse(JSON.stringify(element));
          //Update discount_type based on free_qty
          if (modElement?.free_qty > 0) {
            modElement.discount_type = "Scheme";
          }
          modElement.textractProduct = "";
          modElement.id = element?.textractProduct?.stockistfile_detail_code ? element?.textractProduct?.stockistfile_detail_code : element.id;
          rows.push(flattenObject(modElement));
        });
    return rows;
  };
  const fetchInvoiceDetails = async () => {
    setIsLoading(true);
    try {
      const response = await getInvoiceDetails(stockist_invoice_attachment_id as string, false, company_code); //M10-9862
      dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));

      if (invoicesTextractData?.length > 0) {
        //M10-9685-MRP Related Issue
        const data = response?.data?.data?.invoice?.invoiceProducts?.map((item: any) => ({ ...item, unique_key: item?.invoice_product_id }));
        // setMappedData(invoicesTextractData);
        setMappedData(data || []);
      } else if (response?.data?.data?.invoice?.invoiceProducts?.length > 0) {
        setMappedData(response?.data?.data?.invoice?.invoiceProducts || []);
        navigate(`/transactions/invoice/product-mapping/${stockist_invoice_attachment_id}`);
      } else {
        setMappedData([]);
      }
      if (invoicesTextractData?.length == 0) {
        dispatch(
          invoiceActions.setInvoicesTextractData(
            response?.data?.data?.invoice?.invoiceProducts?.map((item: any) => ({
              invoice_product_id: item?.invoice_product_id,
              unique_key: item?.invoice_product_id,
              invoice_id: response?.data?.data?.invoice?.invoice_id,
              item_description: item?.item_description,
              textractProduct_item_description: item?.textractProduct?.item_description,
              item_code: item?.item_code,
              quantity: item?.quantity,
              gst: item?.p_gst_perc,
              cash_dis_perc: Number(item?.p_cash_discount_perc) ?? 0,
              ptr: Number(item?.ptr),
              pts: Number(item?.pts), //M10-10856
              discount_type: item?.discount_type,
              free_qty: item?.free_qty,
              batch_no: item?.batch_no,
              inv_rate: String(item?.inv_rate),
              inv_mrp: String(item?.inv_mrp),
              discount_amt: String(item?.discount_amt),
              counter_code: response?.data?.data?.counter_code,
              is_item_unknown: item?.is_item_unknown,
              gross_amt: String((Number(item?.ptr) * Number(item?.quantity))?.toFixed(2)),
              id: item?.textractProduct?.stockistfile_detail_code,  //Add for serial No
            })) || []
          )
        );
      }
      const isEwayExempt = response?.data?.data?.orderCodes?.every((code: any) => code?.reference_order?.eway_exempt === true);
      setEwayExempt(isEwayExempt);

      if (response?.data?.data?.eWayBillDtl?.einvoice_status !== "accepted" && !isEwayExempt) {
        setIsEwayApplicable(response?.data?.data?.is_eway_applicable);
      }
      if (response?.data?.data?.invoice?.cash_discount) {
        const invoice = response?.data?.data?.invoice;
        const cashDiscount = Number(invoice?.cash_discount);
        const grossAmount = Number(invoice?.gross_amount);
        let discountPercentage = 0;
        let total = 0; //M10-10754 Start
        invoice?.invoiceProducts?.forEach((item: any) => {
          const percentage = Number(item?.discount_perc) / 100 || 0;
          const quantity = Number(item?.quantity) || 0;
          const rate = Number(item?.inv_rate) || 0;
          const gross = Number(item?.gross_amt) || 0;

          const discountAmount = percentage * quantity * rate;

          const discount = !isNaN(Number(item?.discount_amt)) && Number(item?.discount_amt) !== 0
            ? Number(item.discount_amt)
            : Number(discountAmount.toFixed(2)) || 0;

          // Skip items where gross_amt is not a number or is 0
          if (!gross || isNaN(gross)) return;

          total += gross - (isNaN(discount) ? 0 : discount);
        });//M10-10754 - end
        if (grossAmount > 0) {
          discountPercentage = total !== 0 ? Number(((cashDiscount / total) * 100).toFixed(2)) : 0;//M10-10754 total
        }
        setCashDiscountAmount(cashDiscount);
        setCashDiscountPercent(discountPercentage);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  //M10-11001
  function validate(value: any) {
    const regex = /^(?:\d{1,2})(?:\.\d{1,2})?$/;
    return regex.test(value);
  }
  //M10-11001

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };
  const isRequestInProgress = useRef(false);
  const handleSubmitInvoice = useDebounceLeading(async () => {
    if (isRequestInProgress.current) return;
    isRequestInProgress.current = true;
    try {
      await withEventCheck(() => { }, `invoice_${invoiceDetails?.invoice?.invoice_id}`);
      const invoiceActionAllowedResponse = await getInvoiceActionAllowed(
        invoiceDetails?.invoice?.invoice_id,
        invoiceDetails?.stockist_invoice_attachment_id,
        "Entry",
        invoiceDetails?.company_code
      );
      if (!invoiceActionAllowedResponse?.data?.data?.allowed) {
        toast({ description: invoiceActionAllowedResponse?.data?.data?.message, variant: "destructive" });
        return;
      }
      //M10-11001
      if (!validate(cashDiscountPercent)) {
        toast({ description: "Discount percentage must be up to 2 digits and 2 decimal places.", variant: "destructive" });
        return;
      }
      //M10-11001
      if (
        invoiceDetails?.invoice?.new_invoice_date == undefined ||
        invoiceDetails?.invoice?.new_invoice_date == "" ||
        invoiceDetails?.invoice?.new_invoice_date == null ||
        invoiceDetails?.invoice?.new_invoice_date == " "
      ) {
        toast({ description: "Select Invoice Date before updating", variant: "destructive" });
        return;
      }
      const calculatedTotal = calculateTotal();
      const difference = Math.abs(Number(calculatedTotal) - Number(netInvoiceAmount));
      //M10-9685-MRP Related Issue
      const newArrayWithoutUniqueKey = mappedData
        ?.map(({ unique_key, ...rest }) => rest)
        ?.map((invoice) => {
          const val = (Number(invoice?.discount_amt) / (Number(invoice?.inv_rate) * Number(invoice?.quantity))) * 100;
          //M10-11001
          if (invoice.discount_type !== "Scheme") {
            const discountPerc = invoice?.discount_perc ? invoice?.discount_perc : (isNaN(val) ? "0.00" : val.toFixed(2));
            // Skip if both are empty/zero
            if (!validate(discountPerc)) {
              toast({
                description: "Discount percentage must be up to 2 digits and 2 decimal places.",
                variant: "destructive",
              });
              return;
            }
          }
          //M10-11001
          return {
            ...invoice,
            invoice_id: Number(invoiceDetails.invoice?.invoice_id),
            cash_dis_perc: invoice?.cash_dis_perc != null ? Number(invoice.cash_dis_perc) : Number(invoice?.p_cash_discount_perc),
            discount_perc: invoice?.discount_perc ? invoice?.discount_perc : (isNaN(val) ? "0.00" : val.toFixed(2)), //M10-10754
            ptr: Number(invoice?.ptr),
            batch_no: invoice?.batch_no.replace(/\s+/g, "").trim(), //M10-11021
            pts: Number(invoice?.pts), //M10-10856
            ...(invoice?.textractProduct && {
              stockistfile_detail_code: {
                stockistfile_detail_code: invoice?.textractProduct?.stockistfile_detail_code,
              },
            }),
          };
        });
      //M10-9685-MRP Related Issue
      const isValid = validateInvoiceProducts(newArrayWithoutUniqueKey);
      if (!isValid) {
        return;
      }

      const result = newArrayWithoutUniqueKey?.filter(item => item?.mrp_valid == false);
      if (result.length > 0) {
        toast({
          description: `Incorrect MRP. Please check`,
          variant: "destructive",
        });
        return;
      }

      const checkScheme = newArrayWithoutUniqueKey?.filter(item => Number(item?.quantity) <= 0 && Number(item?.free_qty) <= 0);
      if (checkScheme.length > 0) {
        toast({
          description: `Required Quantity or Free Quantity`,
          variant: "destructive",
        });
        return;
      }
      //netAmount=0
      const allZero = newArrayWithoutUniqueKey?.every(item => Number(item?.quantity) === 0);
      console.log(allZero, isNetAmount)
      if (allZero && isNetAmount?.confirm === false) {
        setIsNetAmount((prev: any) => ({ ...prev, status: true }));
        return
      }
      //netAmount=0

      const resultPrice = newArrayWithoutUniqueKey?.filter(item => item?.inv_rate == '' || item?.inv_rate == undefined || item?.inv_rate == null || item?.inv_rate == '0');
      if (resultPrice.length > 0) {
        toast({
          description: `Incorrect Price. Please check ${resultPrice[0].item_description}`,
          variant: "destructive",
        });
        return;
      }
      const resultModel = newArrayWithoutUniqueKey
        ?.filter(item =>
          item?.discount_type === "Scheme" &&
          Number(item?.discount_amt) === 0 &&
          Number(item?.discount_perc) === 0 &&
          Number(item?.free_qty) === 0
        );

      const resultModelTEST = resultModel
        ?.every(item => item?.isTrue == true);

      if (resultModelTEST) {
        setIsApprovalCheck(false)
      }

      if (resultModel.length > 0 && isApprovalCheck) {
        setIsModalOpen(true)
        for (let i = 0; i < resultModel.length; i++) {
          const updatedMappedData = mappedData.map(obj =>
            obj.ucode === resultModel[i].ucode
              ? { ...obj, isTrue: obj.isTrue ?? false }
              : obj
          );

          setMappedData(updatedMappedData);
        }
        setInvalidItem(
          resultModel?.map(item => ({
            ...item,
            isTrue: item.isTrue ?? false
          }))
        );
        return
      }

      if (!netInvoiceAmount) {
        toast({
          description: `Please enter net amount`,
          variant: "destructive",
        });
        return;
      }

      if (difference > 10) {
        toast({
          description: `The difference between calculated amount and net amount should not exceed ₹10`,
          variant: "destructive",
        });
        return;
      }

      if (mappedData?.length === 0) {
        toast({
          description: `Please add at least one product`,
          variant: "destructive",
        });
        return;
      }
      setConfirmingInvoice(true);
      //M10-10639
      try {
        const checkFullyInvoicedRes = await getCheckFullyInvoiced(
          invoiceDetails?.invoice?.invoice_id,
          invoiceDetails?.company_code,
          newArrayWithoutUniqueKey?.map((item) => ({ ...item, p_cash_discount_perc: item.cash_dis_perc.toFixed(2) }))
        );
        if (!checkFullyInvoicedRes?.data?.data?.fullyInvoiced && checkFullyInvoicedRes?.data?.data?.data.length > 0 && !isSaoCheck) {
          setIsModalSOAOpen(true)
          setIsSaoData(checkFullyInvoicedRes?.data?.data?.data)
          return
        }
      } catch (error) {
        console.log(error)
      }


      const currentDate = new Date(invoiceDetails?.invoice?.new_invoice_date);
      const currentYear = currentDate.getFullYear();
      const financialYearStart = new Date(currentDate.getMonth() >= 3 ? currentYear : currentYear - 1, 3, 1);

      const invoiceAccYear = financialYearStart.getFullYear();

      const payloadToValidateInV1 = {
        cmpstockistcode: invoiceDetails?.company_stockist_code,
        invoicenumber_searchcolumn: invoiceDetails?.invoice?.invoice_number || "",
        invoice_accyear: invoiceAccYear,
        company_code: invoiceDetails?.company_code,
      };

      const response = await getInvoiceChangeValidationV1(payloadToValidateInV1);
      if (response?.data?.success !== "success") {
        toast({ description: response?.data?.message, variant: "destructive" });
        setIsLoading(false);
        setConfirmingInvoice(false);
        return;
      }

      const payload2 = {
        data: {
          invoice_id: Number(invoiceDetails.invoice?.invoice_id),
          invoice_number: invoiceDetails?.invoice?.invoice_number,
          cash_discount_perc: String(cashDiscountPercent),
          cash_discount: String(cashDiscountAmount),
          net_amount: netInvoiceAmount,
          stockist_invoice_attachment_id: invoiceDetails?.stockist_invoice_attachment_id,
          // gst_perc: response?.data?.data?.invoice?.gst_perc || "",
          gst_amount: calculateTotalGst()?.toFixed(2),
          gross_amount: String(calculateSubtotal()),
          tcs: String(tcs) || 0,
          tcs_perc: Number(tcs) || 0,
          gst_perc: (calculateSubtotal() === 0) ? "0.00" : ((calculateTotalGst() / calculateSubtotal()) * 100).toFixed(2), // netAmount 0
          tcs_amt: ((calculateSubtotal() - (calculateSubtotal() * cashDiscountPercent) / 100 + calculateTotalGst()) * tcs) / 100,
          confirm: true,
          stockist_id: invoiceDetails?.stockist_id,
          is_manual_discount: cashDiscountAmount > 0,
          // invoice header details sending for backend versioning
          u_code: invoiceDetails?.invoice?.u_code,
          new_invoice_date: invoiceDetails?.invoice?.new_invoice_date,
          // ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
          e_inv_ref_type: invoiceDetails?.invoice?.e_inv_ref_type || null,
          irn: invoiceDetails?.invoice?.irn,
          gst_validated: invoiceDetails?.invoice?.gst_validated,
          dl_validated: invoiceDetails?.invoice?.dl_validated,
          mci_validated: invoiceDetails?.invoice?.mci_validated,
          counter_gst_number: invoiceDetails?.counter_gst_number || "",
          counter_dl_number: invoiceDetails?.counter_dl_number || "",
          counter_mci_number: invoiceDetails?.counter_mci_number || "",
          invoice_num_modified: false,
          counter_data_validation: false,
          invoiceProducts: newArrayWithoutUniqueKey,
          textract: invoiceDetails?.invoice?.textract,
        },
        primary_key: Number(invoiceDetails?.invoice?.invoice_id),
        event_type: "INVOICE_EDIT",
      };
      const res = await entryInvoice(payload2, company_code);

      // const response = await withEventCheck(
      //   () => {
      //     return getInvoiceDetails(stockist_invoice_attachment_id as string, false);
      //   },
      //   res?.data?.data?.invoice?.eventStreamCreated?.streamId
      // );
      // dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));
      toast({ description: "Invoice confirmed successfully", variant: "default" });

      try {
        // const payload = {
        //   data: newArrayWithoutUniqueKey,
        //   primary_key: Number(invoiceDetails?.invoice?.invoice_id),
        //   event_type: "INVOICE_PRODUCT_ADD",
        // };
        // const res = await updateInvoice(payload);
        const response = await withEventCheck(
          () => {
            return getInvoiceDetails(stockist_invoice_attachment_id as string, false, company_code);
          },
          res?.data?.data?.[res?.data?.data]?.eventStreamCreated?.streamId
        );
        dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));
        resetFormFields();
        setIsLoading2(false);
        navigate("/transactions/invoice");
      } catch (error: any) {
        console.log(error);
        toast({ description: error?.response?.data?.message, variant: "destructive" });
        setConfirmingInvoice(false);
        setIsLoading2(false);
      }
    } catch (error: any) {
      console.log(error, "error");
      toast({ description: error?.response?.data?.message, variant: "destructive" });
      setIsLoading2(false);
    } finally {
      isRequestInProgress.current = false;
      setConfirmingInvoice(false);
      setIsLoading2(false);
    }
  }, 1000);

  const fetchProductsDataForItemCode = async (query: string) => {
    if (useOrderedProducts === "unknown") {
      return;
    }
    try {
      return await getSimilarCompanyProducts(invoiceDetails?.company_code, "", query, 1, 10);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchOrderedProductsByItemCode = async (query: string) => {
    if (useOrderedProducts === "unknown") {
      return;
    }
    try {
      return await getOrderedProducts({
        product_name: "",
        counter_code: invoiceDetails?.counter_code,
        item_code: query,
        page: 1,
        page_size: 10,
        company_stockist_code: invoiceDetails?.company_stockist_code,
        invoice_date: invoiceDetails?.invoice?.new_invoice_date,
        company_code: invoiceDetails?.company_code,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handlePercentageChange = (e?: any) => {
    const { setValue }: any = smartFormInstance;
    const percentage = Number(e) / 100;
    const discountAmount = percentage * quantity * price;
    setDiscountAmount(Number(discountAmount?.toFixed(2)));
    setDiscountPercentage(Number(e));
    setValue("discountAmount", discountAmount?.toFixed(2));
    setValue("discountPercentage", Number(e));
  };

  const handleAmountChange = (e?: any) => {
    const { setValue }: any = smartFormInstance;
    const amount = Number(e);
    const discountPercentage = (amount / (quantity * price)) * 100;
    setDiscountAmount(amount);
    setDiscountPercentage(Number(discountPercentage?.toFixed(2)));
    setValue("discountAmount", amount);
    setValue("discountPercentage", discountPercentage?.toFixed(2));
  };

  // const handleBatchNo = (e?: any) => {
  //   setBatchNo(e);
  // };

  const handleAutocompleteChange = async (data: any) => {
    const { setValue }: any = smartFormInstance;
    const value = data;
    if (value) {
      const { isCustom } = value;
      !isCustom && setValue("itemName", value?.product_name);
      !isCustom && setValue("itemCode", value?.item_code);
      // setValue("mrp", value?.mrp || "");
      // setValue("price", value?.ptr || "");
      setPrice(value?.ptr);
      setValue("batchNo", "");
      setValue("discountAmount", "");
      setValue("discountPercentage", "");
      setValue("freeQty", "");
      setValue("quantity", "");
      setValue("schemeType", "");
      setValue("gst", "");
      setValue("itemPrice", "");
      setValue("price", "");
      setValue("ptr", "");
      setDiscountPercentage(0);
      setDiscountAmount(0);

      setItemCode(value?.item_code);
    } else {
      // setValue("mrp", "");
      // setValue("price", "");
      setValue("schemeType", "");
      setValue("freeQty", "");
      setValue("discountPercentage", "");
      setValue("discountAmount", "");
      setValue("batchNo", "");
      setValue("itemCode", "");
    }
  };

  const resetFormFields = () => {
    const { reset }: any = smartFormInstance;

    // Reset form fields
    reset();

    // Clear additional state values
    setQuantity(0);
    setPriceList([]);
    setPrice(0);
    setBatchList([]);
    setDiscountPercentage(0);
    setDiscountAmount(0);
    setSelectedPriceIdentifier({
      key: "",
      description: "",
      priceldentifier_id: 0,
    });
    setFetchTrigger(fetchTrigger + 1);
    // setTimeout(() => {
    //   // Focus the Item Name input using the input's ID
    //   const itemNameInput = document.querySelector('[name="itemName"]') as HTMLInputElement;
    //   if (itemNameInput) {
    //     itemNameInput.focus();
    //   }
    // }, 0);
  };

  const handleRadioButtonsForForm = (value: string) => {
    setUseOrderedProducts(value);
    resetFormFields();
  };

  /**
   * Calculates the total invoice amount including GST and discounts
   * Formula: Sum of [(Gross Amount - Discount) + GST] for each item
   * @returns {number} Total invoice amount
   */
  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const amountAfterCashDiscount = subtotal - (subtotal * cashDiscountPercent) / 100;
    const totalGst = calculateTotalGst();
    const tcsCalculatedAmount = amountAfterCashDiscount + totalGst + ((amountAfterCashDiscount + totalGst) * tcs) / 100;
    // return amountAfterCashDiscount + totalGst;
    return tcsCalculatedAmount;
  };

  /**
   * Calculates the raw subtotal before any discounts or taxes
   * Simply sums up the gross amounts of all items
   * @returns {number} Subtotal amount
   */
  const calculateInitialSubtotal = () => {
    let total = 0;
    mappedData?.forEach((item: any) => {
      const percentage = Number(item?.discount_perc) / 100 || 0;//M10-10754
      const quantity = Number(item?.quantity) || 0;
      const rate = Number(item?.inv_rate) || 0;
      const discountAmount = percentage * quantity * rate;

      const gross = Number(item.gross_amt);
      const parsedDiscountAmt = Number(item?.discount_amt);
      const discount = !isNaN(parsedDiscountAmt) && parsedDiscountAmt !== 0
        ? parsedDiscountAmt
        : Number(discountAmount.toFixed(2)) || 0;//M10-10754

      // Skip items where gross_amt is not a number or is 0
      if (!gross || isNaN(gross)) return;

      total += gross - (isNaN(discount) ? 0 : discount);
    });
    return total;
  };

  /**
   * Calculates final subtotal after all discounts (including cash discount)
   */
  const calculateSubtotal = () => {
    const initialSubtotal = calculateInitialSubtotal();
    return initialSubtotal;
  };

  // const calculateGstAmount = (item: any) => {
  //   const { gross_amt, gst, discount_amt } = item;
  //   const amountAfterDiscount = Number(gross_amt) - Number(discount_amt);
  //   const gstAmount = (amountAfterDiscount * Number(gst)) / 100;
  //   return gstAmount;
  // };

  const calculateTotalGst = () => {
    let total = 0;
    mappedData?.forEach((item: any) => {
      const { gross_amt, gst, discount_amt, p_gst_perc } = item;

      // Skip items with 0 or falsy gross amount
      if (!gross_amt || Number(gross_amt) === 0) return;

      //M10-10754 - start
      const percentage = Number(item?.discount_perc) / 100 || 0;
      const quantity = Number(item?.quantity) || 0;
      const rate = Number(item?.inv_rate) || 0;

      const discountAmount = percentage * quantity * rate;

      // Ensure discount_amt is a valid number, else fall back to discountAmount or 0
      const parsedDiscountAmt = Number(discount_amt);
      const discount = !isNaN(parsedDiscountAmt) && parsedDiscountAmt !== 0
        ? parsedDiscountAmt
        : Number(discountAmount.toFixed(2)) || 0;

      //M10-10754 - end
      const amountAfterItemDiscount = Number(gross_amt) - Number(discount);
      const amountAfterCashDiscount = amountAfterItemDiscount - (amountAfterItemDiscount * cashDiscountPercent) / 100;

      const gstAmount = (amountAfterCashDiscount * Number(gst || p_gst_perc)) / 100;
      total += gstAmount;
    });
    return total;
  };

  useEffect(() => {
    if (discountAmount || discountPercentage) {
      if (discountAmount) {
        handleAmountChange(discountAmount);
      } else {
        handlePercentageChange(discountPercentage);
      }
    }
  }, [quantity]);

  /**
   * Effect hook to fetch price and batch data when item code changes
   * Only runs for known/ordered products (not unknown items)
   * Makes parallel API calls for efficiency
   */
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch both price list and batch list simultaneously
        Promise.all([
          getInvoicePriceList(itemCode).then((res: any) => setPriceList(res?.data?.data)),
          getInvoiceBatchList(itemCode, company_code).then((res: any) => {
            const apiBatches = res?.data?.data || [];
            const combinedBatches = [...apiBatches, ...unknownBatch];
            setBatchList(combinedBatches);
          }),
        ]);
      } catch (error) {
        console.log(error);
      }
    };

    // Only fetch data if we have a valid item code and it's not an unknown product
    if (itemCode && useOrderedProducts !== "unknown") {
      fetchData();
    }
  }, [itemCode, useOrderedProducts, fetchTrigger]);

  /**
   * Effect hook to fetch initial invoice details
   * Runs once on component mount
   */

  useEffect(() => {
    if (invoicesTextractData?.length > 0) {
      const itemCodes: Set<string> = new Set();
      invoicesTextractData?.filter((item: any) => item?.gst == "0")?.map((item: any) => itemCodes.add(item?.item_code));
      const itemCodesString = Array.from(itemCodes).join(",");
      if (itemCodesString.length > 0) {
        getProductGstDetails(itemCodesString).then((response: any) => {
          const updatedData = invoicesTextractData.map((item: any) => {
            const gstDetails = response?.data?.find((gst: any) => gst?.item_code === item?.item_code);
            return {
              invoice_product_id: item?.invoice_product_id,
              unique_key: item?.invoice_product_id,
              invoice_id: invoiceDetails?.invoice?.invoice_id,
              item_description: item?.item_description,
              item_code: item?.item_code,
              quantity: item?.quantity,
              gst: item?.gst == "0" ? gstDetails?.gst_pc : item?.gst || "0",
              cash_dis_perc: item?.cash_dis_perc ?? 0,
              ptr: Number(item?.ptr) || 0,
              pts: Number(item?.pts) || 0, //M10-10856
              discount_type: item?.discount_type,
              free_qty: item?.free_qty,
              batch_no: item?.batch_no,
              inv_rate: item?.inv_rate,
              inv_mrp: item?.inv_mrp,
              discount_amt: item?.discount_amt,
              counter_code: invoiceDetails?.counter_code,
              is_item_unknown: item?.is_item_unknown,
              gross_amt: (Number(item?.ptr) * Number(item?.quantity))?.toFixed(2),
              ucode: generateUniqueID(), //M10-9682
              id: item?.stockistfile_detail_code,  //Add for serial No
            };
          });
          dispatch(invoiceActions.setInvoicesTextractData(updatedData));
          setMappedData(updatedData);
        });
      } else {
        //M10-9682
        const updatedData = invoicesTextractData.map((item: any) => ({
          ...item,
          id: item?.stockistfile_detail_code,  //Add for serial No
          ucode: generateUniqueID(),
        }));
        dispatch(invoiceActions.setInvoicesTextractData(updatedData));
        setMappedData(updatedData); //M10-9682
      }
    }
    // if (invoiceDetails?.length == 0) {
    //   fetchInvoiceDetails();
    // }
  }, []);
  //M10-9685-MRP Related Issue
  useEffect(() => {
    dispatch(invoiceActions.setInvoiceDetails([]));
    dispatch(invoiceActions.setInvoicesTextractData([]));
    resetFormFields();
    fetchInvoiceDetails();
  }, [stockist_invoice_attachment_id]);
  //M10-9685-MRP Related Issue

  if (isLoading) {
    return <Loader />;
  }

  return (
    <InvoiceLayout>
      <Fragment>
        <Transition
          as={Fragment}
          show={isRemarksShown}
          enter="transition transition ease-in-out duration-200 transform"
          enterFrom="translate-x-full"
          enterTo="translate-x-0"
          leave="transition  ease-in-out duration-200 transform"
          leaveFrom="translate-x-0"
          leaveTo="translate-x-full"
        >
          <div className="fixed right-0 inset-0 top-0 z-[500]">
            <InvoiceRemarks invoiceApprovalData={invoiceDetails} invoice_id={Number(invoiceDetails?.invoice?.invoice_id)} ref={ref} />
          </div>
        </Transition>
      </Fragment>
      <div className="flex justify-between px-[3.75rem] mt-6  pb-12 shadow-md border-b-[1px] border-b-[#E9E9E9]">
        <div className="flex items-center justify-between w-full">
          <div className="flex flex-col">
            <div
              className="flex items-center cursor-pointer font-semibold px-0 py-2 text-lg text-[#7F56D9]"
              onClick={() => navigate("/transactions/invoice/0")}
            >
              <img src={PurpleLeftArrowIcon} alt="back" className="w-3 h-3 mr-3" />
              Back to Invoices
            </div>
            <h1 className="text-[#49484C] font-bold text-[2rem]">Invoice Entry</h1>
          </div>
        </div>
        {/* //M10-11601 */}
        <div className="absolute right-4 flex flex-row gap-3 items-end mt-24">
          {/* Versioning */}
          <div
            onClick={() => setVersioningModal((prev) => !prev)}
          >
            <img src={Book} alt="Version" className="h-10 w-14 "/>
          </div>

          {/* Remarks */}
          {viewRemarks && (
            <div
              onClick={() => setIsRemarksShown(true)}
              className="p-2 bg-white cursor-pointer"
            >
              <MessageCircle className="text-gray-500 h-6 w-6" />
            </div>
          )}
        </div>

      </div>
      <div className="px-[3.75rem] mx-auto mt-10 relative">
        {VersioningModal && (
          <div ref={outSideClickRef}>
            <VersioningCrate type="Invoice" invoiceId={invoiceDetails?.invoice?.invoice_id} stockistInvAttachmentId={invoiceDetails?.stockist_invoice_attachment_id} />
          </div>
        )}
        <ul className="mt-5">
          <li className="my-5 mb-10 rounded-lg">
            <InvoiceDetailCard
              isExpandedInitial={true}
              isExpandable={false}
              status={invoiceDetails?.fileStatusHdr?.fuid_status_desc}
              checkDataType={false}
              data={getInvoiceDetailsInfo(invoiceDetails)}
              viewDetails={false}
              invoiceData={invoiceDetails}
              // handleAddItem={handleAddItem}
              fetchInvoiceDetails={fetchInvoiceDetails}
              tab={0}
              isEwayExempt={isEwayExempt}
            />
          </li>
        </ul>
        {invoiceDetails?.invoice && (
          <div className="p-0 mb-10 border-2 rounded-lg">
            <div className="m-5">
              <div className="flex items-center justify-between">
                <p className="mb-2 text-lg font-semibold">Invoice Details</p>
                <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
                  <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
                </Button>
              </div>
              <div className="flex items-center gap-x-5">
                <div className="flex items-center mb-5 space-x-6">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="orderedProducts"
                      name="productType"
                      value="ordered"
                      checked={useOrderedProducts === "ordered"}
                      onChange={() => handleRadioButtonsForForm("ordered")}
                      className="mr-2"
                    />
                    <label htmlFor="orderedProducts" className="text-sm text-gray-500">
                      Ordered Products
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="companyProducts"
                      name="productType"
                      value="company"
                      checked={useOrderedProducts === "company"}
                      onChange={() => handleRadioButtonsForForm("company")}
                      className="mr-2"
                    />
                    <label htmlFor="companyProducts" className="text-sm text-gray-500">
                      Company Products
                    </label>
                  </div>
                </div>
                <div className="flex items-center mb-5">
                  <input
                    type="radio"
                    id="unknownOrder"
                    name="productType"
                    value="unknown"
                    checked={useOrderedProducts === "unknown"}
                    onChange={() => handleRadioButtonsForForm("unknown")}
                    className="mr-2"
                  />
                  <label htmlFor="unknownOrder" className="text-sm text-gray-500">
                    Unknown Order
                  </label>
                </div>
              </div>
              <div
                className={`transition-all duration-500 ease-in-out ${isExpanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}
                style={{ transitionProperty: "max-height, opacity" }}
              >
                <InvoiceEntryForm
                  handleAddProduct={handleAddProduct}
                  smartFormInstance={smartFormInstance}
                  useOrderedProducts={useOrderedProducts}
                  handleAutocompleteChange={handleAutocompleteChange}
                  selectedPriceIdentifier={selectedPriceIdentifier}
                  setSelectedBatch={setSelectedBatch}
                  schema={schema}
                  fetchOrderedProductsByItemCode={fetchOrderedProductsByItemCode}
                  fetchProductsDataForItemCode={fetchProductsDataForItemCode}
                  batchList={batchList}
                  priceList={priceList}
                  gstAmbiguous={gstAmbiguous}
                  setGstAmbiguous={setGstAmbiguous}
                  setPrice={setPrice}
                  quantity={quantity}
                  setQuantity={setQuantity}
                  priceIdentifierList={priceIdentifierList}
                  setSelectedPriceIdentifier={setSelectedPriceIdentifier}
                  discountPercentage={discountPercentage}
                  discountAmount={discountAmount}
                  handlePercentageChange={handlePercentageChange}
                  handleAmountChange={handleAmountChange}
                />
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col mt-5 gap-x-5 [@media(min-width:1580px)]:flex-row">
          <div className="flex flex-col w-full gap-4 p-8 border rounded-lg [@media(min-width:1580px)]:w-9/12">
            <SubTable
              isLoading={isLoading2}
              title="Items Added"
              subtitle="Review and manage all items added"
              showheader={true}
              columns={columns}
              data={rowsForItemsAddedTable(false)}
              enableShowError={true}
            />
            <SubTable
              isLoading={isLoading2}
              title="Unknown Order"
              subtitle="Review and manage all items added"
              showheader={true}
              columns={columns2}
              data={rowsForItemsAddedTable(true)}
              enableShowError={true}
            />
            <Button
              className="w-fit h-9 mt-0 font-normal border border-[#D0D0D0]  bg-[#F1F1F1] shadow-sm"
              onClick={() => {
                navigate(`/transactions/invoice/product-mapping/${invoiceDetails?.stockist_invoice_attachment_id}`);
              }}
            >
              Map Products
            </Button>
          </div>

          <div className="w-4/12 p-8 mt-10 border rounded-lg [@media(min-width:1580px)]:w-3/12 [@media(min-width:1580px)]:mt-0">
            <p className="mb-2 text-lg font-semibold">Calculations</p>
            <div className="flex flex-col pb-10 gap-y-1">
              <p className="flex justify-between py-2 text-sm">
                Subtotal{" "}
                <span className="">
                  ₹
                  {Number((calculateSubtotal() - cashDiscountAmount)?.toFixed(2)).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">Cash Discount %</span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="0"
                    value={cashDiscountPercent}
                    onChange={(e: any) => handleCashDiscountPercentChange(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">Cash Discount Amount</span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="0"
                    value={cashDiscountAmount}
                    onChange={(e: any) => handleCashDiscountAmountChange(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">TCS %</span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="TCS"
                    value={tcs}
                    onChange={(e: any) => setTcs(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              <p className="flex justify-between py-2 text-sm">
                GST Amount
                <span className="font-semibold">
                  ₹
                  {Number(calculateTotalGst()?.toFixed(2)).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </p>
              <p className="flex justify-between py-2 text-sm">
                Total (as calculated){" "}
                <span className="font-semibold">
                  ₹
                  {Number(calculateTotal()?.toFixed(2)).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">
                  Net Inv. Amt.<span className="text-red-500"> *</span>
                </span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="Net Amt."
                    value={netInvoiceAmount}
                    onChange={(e: any) => setNetInvoiceAmount(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              <Button
                disabled={isRequestInProgress.current}
                className="w-full h-9 mt-5 font-normal text-white bg-[#8051FF] shadow-sm"
                isLoading={isConfirmingInvoice}
                loaderSize="small"
                onClick={handleSubmitInvoice}
                module={fineGrainedPermissionsKeys.INVOICE.CONFIRMINVOICE.module}
                action={fineGrainedPermissionsKeys.INVOICE.CONFIRMINVOICE.action}
              >
                Confirm Invoice
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={isEwayApplicable} isHeader={false} onCloseModal={() => setIsEwayApplicable(false)} title="Eway Bill">
        <EwayDetails
          onSuccess={fetchInvoiceDetails}
          onCloseModal={() => {
            setIsEwayApplicable(false);
          }}
          invoiceData={invoiceDetails}
        />
      </Modal>
      <Modal isOpen={isModalOpen} isHeader={false} onCloseModal={() => setIsModalOpen(false)} title="Vertify">
        <div className="flex flex-col gap-y-2 mb-4 w-[540px] max-h-[90vh] mx-auto px-6 bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold text-gray-800">
              You have not entered scheme, are you sure you want to continue?
            </p>
            <Button className="bg-transparent -mr-3" onClick={() => setIsModalOpen(false)}>
              <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
            </Button>
          </div>

          {/* Scrollable Table Wrapper */}
          <div className="overflow-y-auto max-h-[400px] mt-2">
            <table className="w-full text-sm text-gray-700 border border-gray-200 rounded">
              <thead className="bg-gray-100 text-left sticky top-0 z-10">
                <tr>
                  <th className="p-2 border-b">Item Code</th>
                  <th className="p-2 border-b">Item Description</th>
                  <th className="p-2 border-b">Batch No</th>
                  <th className="p-2 border-b">Quantity</th>
                  <th className="p-2 border-b">Status</th>
                </tr>
              </thead>
              <tbody>
                {invalidItem?.map((item, index) => (
                  <tr key={index}>
                    <td className="p-3 border-b">{item?.item_code}</td>
                    <td className="p-3 border-b">{item?.item_description}</td>
                    <td className="p-3 border-b">{item?.batch_no}</td>
                    <td className="p-3 border-b">{item?.quantity}</td>
                    <td className="p-3 border-b">
                      <Toggle
                        checked={item?.isTrue}
                        onChange={(checked: boolean) => {
                          const updatedMappedData = mappedData.map(obj =>
                            obj.ucode === item.ucode
                              ? { ...obj, isTrue: checked }
                              : obj
                          );
                          const updatedMapped = invalidItem.map(obj =>
                            obj.ucode === item.ucode
                              ? { ...obj, isTrue: checked }
                              : obj
                          );
                          setMappedData(updatedMappedData);
                          setInvalidItem(updatedMapped);
                          const resultModelTEST = updatedMapped.every(item => item?.isTrue === true);

                          setIsApprovalCheck(!resultModelTEST);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            {/* M10-11544 */}
            <Button
              className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg"
              onClick={() => {
                const updatedMapped = invalidItem.map(obj => ({
                  ...obj,
                  isTrue: false
                }));
                 const updatedMappedData = mappedData.map(obj => ({
                  ...obj,
                  isTrue: false
                }));
                setMappedData(updatedMappedData)
                setInvalidItem(updatedMapped);
                setIsApprovalCheck(true);
                setIsModalOpen(false);
              }}
            >
              {/* M10-11544 */}
              Cancel
            </Button>
            <Button
              loaderSize="small"
              isLoading={isLoading}
              className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
              onClick={() => { setIsModalOpen(false) }}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
      {/* M10-10639 */}
      <Modal isOpen={isModalSOAOpen} isHeader={false} onCloseModal={() => setIsModalSOAOpen(false)} title="Vertify">
        <div className="flex flex-col gap-y-2 mb-4 w-[910px] max-h-[90vh] mx-auto px-6 bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold text-gray-800">
              Are you sure you want to continue?
            </p>
            <Button className="bg-transparent -mr-3" onClick={() => setIsModalSOAOpen(false)}>
              <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
            </Button>
          </div>

          {/* Scrollable Table Wrapper M10-11277*/}
          <div className="overflow-y-auto max-h-[400px] mt-2">
            <table className="w-full text-sm text-gray-700 border border-gray-200 rounded">
              <thead className="bg-gray-100 text-left sticky top-0 z-10">
                <tr>
                  <th className="p-2 border-b">Item Code</th>
                  <th className="p-2 border-b">Order Code</th>
                  {/* Order Details Header */}
                  <th className="p-2 border-b text-center" colSpan={3}>Order Details</th>
                  {/* Invoice Details Header */}
                  <th className="p-2 border-b text-center" colSpan={3}>Invoice Details</th>
                </tr>
                <tr>
                  <th className="p-2 border-b"></th>
                  <th className="p-2 border-b"></th>
                  <th className="p-2 border-b">Quantity</th>
                  <th className="p-2 border-b">Disc Type</th>
                  <th className="p-2 border-b">Value</th>
                  <th className="p-2 border-b">Quantity</th>
                  <th className="p-2 border-b">Disc Type</th>
                  <th className="p-2 border-b">Value</th>
                </tr>
              </thead>
              <tbody>
                {isSaoData?.map((item, index) => (
                  <tr key={index}>
                    <td className="p-3 border-b">{item?.item_code || "-"}</td>
                    <td className="p-3 border-b">{item?.order_code || "-"}</td>

                    {/* Conditionally Render Order Details */}
                    {item?.order_discount_on_ptr && (
                      <>
                        <td className="p-3 border-b">{item?.order_quantity}</td>
                        <td className="p-3 border-b">Discount On PTR</td>
                        <td className="p-3 border-b">{item?.order_discount_on_ptr || "-"}</td>
                      </>
                    )}

                    {/* Conditionally Render Invoice Details */}
                    {item?.invoice_discount_on_ptr && (
                      <>
                        <td className="p-3 border-b">{item?.invoice_quantity}</td>
                        <td className="p-3 border-b">Discount On PTR</td>
                        <td className="p-3 border-b">{item?.invoice_discount_on_ptr || "-"}</td>
                      </>
                    )}

                    {/* Conditionally Render Scheme and Fixed Price - Order */}
                    {item?.order_free_qty && (
                      <>
                        <td className="p-3 border-b">{item?.order_quantity}</td>
                        <td className="p-3 border-b">Scheme</td>
                        <td className="p-3 border-b">{item?.order_free_qty || "-"}</td>
                      </>
                    )}
                    {item?.order_fixed_price && (
                      <>
                        <td className="p-3 border-b">{item?.order_quantity}</td>
                        <td className="p-3 border-b">Fixed Price</td>
                        <td className="p-3 border-b">{item?.order_fixed_price || "-"}</td>
                      </>
                    )}

                    {/* Conditionally Render Scheme and Fixed Price - Invoice */}
                    {item?.invoice_free_qty && (
                      <>
                        <td className="p-3 border-b">{item?.invoice_quantity}</td>
                        <td className="p-3 border-b">Scheme</td>
                        <td className="p-3 border-b">{item?.invoice_free_qty || "-"}</td>
                      </>
                    )}
                    {item?.invoice_fixed_price && (
                      <>
                        <td className="p-3 border-b">{item?.invoice_quantity}</td>
                        <td className="p-3 border-b">Fixed Price</td>
                        <td className="p-3 border-b">{item?.invoice_fixed_price || "-"}</td>
                      </>
                    )}
                    {/* M10-11277 */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg" onClick={() => setIsModalSOAOpen(false)}>
              Cancel
            </Button>
            <Button
              disabled={isApprovalCheck}
              loaderSize="small"
              isLoading={isLoading}
              className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
              onClick={() => {
                setIsModalSOAOpen(false)
                setIsSaoCheck(true)
              }}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
      {/* NetAmount is 0 */}
      <Modal isOpen={isNetAmount.status} isHeader={false} onCloseModal={() => setIsNetAmount((prev: any) => ({ ...prev, status: false }))} title="Vertify">
        <div className="flex flex-col gap-y-2 mb-4 w-[640px] max-h-[90vh] mx-auto px-6 bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center">
            <p className="text-sm font-medium text-gray-900 leading-relaxed">
              <span className="text-yellow-800">⚠️ <strong>Warning:</strong> All product quantities are <span className="text-red-600 font-bold">0</span>. Do you still want to continue?</span>
            </p>
            <Button className="bg-transparent -mr-3" onClick={() => setIsNetAmount((prev: any) => ({ ...prev, status: false }))}>
              <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
            </Button>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg" onClick={() => setIsNetAmount((prev: any) => ({ ...prev, status: false }))}>
              Cancel
            </Button>
            <Button
              loaderSize="small"
              className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
              onClick={() => setIsNetAmount((prev: any) => ({ ...prev, status: false, confirm: true }))}
            >
              Proceed
            </Button>

          </div>
        </div>
      </Modal>
    </InvoiceLayout>
  );
};
